/* Nuvò · Metodi di pagamento — cambio scheda in «Scegli come pagare» */
(function () {
  function init(root) {
    if (!root || root.getAttribute('data-npg-ready')) return;
    root.setAttribute('data-npg-ready', '1');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-npg-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-npg-panel]'));
    if (!tabs.length) return;
    function show(i, focus) {
      tabs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p, k) {
        var on = k === i;
        p.classList.toggle('is-off', !on);
        p.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i, false); });
      t.addEventListener('keydown', function (e) {
        var n = tabs.length, j = -1;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') j = (i + 1) % n;
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') j = (i - 1 + n) % n;
        if (e.key === 'Home') j = 0;
        if (e.key === 'End') j = n - 1;
        if (j > -1) { e.preventDefault(); show(j, true); }
      });
    });
    /* nel theme editor: cliccando un blocco «Metodo» si apre la sua scheda */
    root.addEventListener('shopify:block:select', function (e) {
      var i = tabs.indexOf(e.target);
      if (i > -1) show(i, false);
    });
    show(0, false);
  }
  function all() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-npg-met]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
